import { Button } from "@mui/material";
import React, { FC, useRef } from "react";

interface Props {
  href: string;
  text: string;
}

export const DownloadBtn: FC<Props> = ({ href, text }) => {
  const videoRef = useRef<HTMLAnchorElement>(null);

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        style={{ marginLeft: "10px", marginBottom: "20px" }}
        onClick={() => {
          videoRef.current?.click();
        }}
      >
        Download {text}
      </Button>
      <a href={href} download ref={videoRef} style={{ display: "none" }}>
        Download
      </a>
    </>
  );
};
